import script from "./PortalApp.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortalApp.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./PortalApp.vue3.vue?vue&type=style&index=0&id=56878086&lang=scss"
import "./PortalApp.vue3.vue?vue&type=style&index=1&id=56878086&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56878086"]])

export default __exports__